import { gql, useQuery } from '@apollo/client'
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect, useState } from 'react'
import RegisterContent from '../../../content/register'
import { FormButton } from './FormButton'

export const GET_PROFILE_DETAILS = gql(`
    query getProfile{
        me {
            handle
        }
    }
`)

const { userDetailsForm } = RegisterContent

const UserDetailsForm = ({
  referredBy,
  onUsernameUpdate,
  goToNextStep,
  closeRegistration,
  usernameCharactersValid,
}: {
  referredBy: string
  onUsernameUpdate: (referredBy: string) => void
  goToNextStep: () => void
  closeRegistration: () => void
  usernameCharactersValid: boolean
}) => {
  const [handle, setHandle] = useState('')
  const [loadingHandle, setLoadingHandle] = useState(true)
  const { isAuthenticated, user } = useAuth0()

  const { data: userProfileResponse, loading: userProfileLoading } = useQuery(
    GET_PROFILE_DETAILS,
    { skip: !isAuthenticated }
  )

  useEffect(() => {
    setLoadingHandle(userProfileLoading ? true : false)
  }, [userProfileLoading])

  useEffect(() => {
    if (userProfileResponse) {
      setHandle(userProfileResponse?.me?.handle ?? '')
    }
  }, [userProfileResponse])

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        goToNextStep()
      }}
      className="UserDetailsForm flex flex-col gap-4 mt-6"
      data-testid="user-details-form"
      autoComplete="off"
    >
      <div>
        <label htmlFor="username-input">Username</label>
        <input
          type="text"
          id="username-input"
          value={
            handle || (loadingHandle ? 'loading...' : 'Username not available')
          }
          disabled
          name="username"
          readOnly
        />
      </div>
      <div>
        <label htmlFor="email-input">Email</label>
        <input
          type="text"
          id="email-input"
          value={user?.email || 'Email not available'}
          disabled
          name="email"
          readOnly
        />
      </div>
      <p className="text-sm text-2026-form-gray-light text-center font-sora leading-[140%]">
        {userDetailsForm.helpText}
      </p>

      <div>
        <p className="text-2026-small text-2026-form-primary text-center mb-2">
          {userDetailsForm.referText}
        </p>
        <input
          type="text"
          id="referrer-username-input"
          placeholder="username"
          value={referredBy}
          onChange={(e) => onUsernameUpdate(e.target.value || '')}
          name="refer-username"
          minLength={3}
          maxLength={20}
          required={!!referredBy.length}
        />
      </div>

      <div className="flex flex-col gap-2 w-[330px] mx-auto">
        <FormButton type="submit" disabled={!usernameCharactersValid}>
          {userDetailsForm.nextButtonLabel}
        </FormButton>
        <FormButton
          variant="secondary"
          type="button"
          onClick={() => closeRegistration()}
        >
          {userDetailsForm.cancelButtonLabel}
        </FormButton>
      </div>
    </form>
  )
}

export default UserDetailsForm
